exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:700px){.info_text[data-v-a9e8f21a]{vertical-align:middle;width:100%}}@media (min-width:700px){.info_text[data-v-a9e8f21a]{vertical-align:middle;width:100%}}.size-title[data-v-a9e8f21a]{font-size:22px}.info_component[data-v-a9e8f21a]{background-color:#f6f6f8;width:100%;line-height:20px;font-family:Roboto;font-style:normal;font-weight:400;font-size:18px;color:#777}", ""]);

// exports
